import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Grid, Backdrop, CircularProgress } from "@material-ui/core";

import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { Wrapper } from "components/wrapper";
import { InfoText, InfoTitle, Photo } from "./organizational-structure-details.styles";
import { SectionTitle } from "components/section";
import { useOrganizationalStructureDetailsState } from "./context/organizational-structure-details-context";
import { useOrganizationalStructureDetailsController } from "./context/organizational-structure-details-controller";
import { PhoneFormatter } from "utils/phone-formatter";

export const OrganizationalStructureDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const { organizationalStructureDetails, loading } = useOrganizationalStructureDetailsState();
  const { onInit } = useOrganizationalStructureDetailsController();

  useEffect(() => {
    if (id) {
      onInit(id);
    }
  }, [id, onInit]);

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Estrutura organizacional", href: "/estrutura-organizacional" },
          { label: organizationalStructureDetails?.person || '' },
        ]}
      />
      <PageTitle>{organizationalStructureDetails?.person || ''}</PageTitle>
      <Wrapper>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5} lg={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Photo src={organizationalStructureDetails?.imageUrl} />
              </Grid>
              <Grid item xs={12}>
                <InfoTitle>Responsável</InfoTitle>
                <InfoText>{organizationalStructureDetails?.person}</InfoText>
              </Grid>
              <Grid item xs={12}>
                <InfoTitle>Horário de atendimento</InfoTitle>
                <InfoText>{organizationalStructureDetails?.openingHours}</InfoText>
              </Grid>
              <Grid item xs={12}>
                <InfoTitle>Endereço</InfoTitle>
                <InfoText>{organizationalStructureDetails?.address}</InfoText>
              </Grid>
              <Grid item xs={12}>
                <InfoTitle>Telefone</InfoTitle>
                <InfoText>{PhoneFormatter.format(organizationalStructureDetails?.phoneContact)}</InfoText>
              </Grid>
              <Grid item xs={12}>
                <InfoTitle>E-mail</InfoTitle>
                <InfoText>{organizationalStructureDetails?.email}</InfoText>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={7} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <SectionTitle style={{ margin: 0 }}>Competências</SectionTitle>
              </Grid>
              <Grid item xs={12}>
                <InfoText>{organizationalStructureDetails?.competence}</InfoText>
              </Grid>
              {organizationalStructureDetails?.biography && (
                <Grid item xs={12}>
                  <SectionTitle style={{ margin: 0 }}>Biografia</SectionTitle>
                  <InfoText>{organizationalStructureDetails?.biography}</InfoText>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
      <Backdrop open={loading} style={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
